import React from 'react';
import {
  Box, FormControl, FormHelperText, InputLabel,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { CustomProvider, DateRangePicker } from 'rsuite';
import { ptBR } from 'rsuite/locales';
import 'rsuite/dist/rsuite-no-reset.min.css';
import './styles.css';

const labelStyles = {
  position: 'absolute',
  zIndex: 999,
  paddingRight: 1,
  paddingLeft: 1,
  backgroundColor: '#F8FAF6',
  transform: 'translate(14px, -9px) scale(0.75)',
  transition:
    'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,max-width 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
};

function DataRangePickerContext({
  inputLabel, initialDateFieldName, endDateFieldName, dateRange, setDateRange,
}) {
  const { getFieldMeta, setFieldValue, setFieldTouched } = useFormikContext();
  const fieldDate1 = getFieldMeta(initialDateFieldName);
  // const fieldDate2 = getFieldMeta(endDate);

  const handleChangeDate = (date) => {
    setDateRange(date);
    setFieldValue(initialDateFieldName, date?.[0]);
    setFieldValue(endDateFieldName, date?.[1]);
    setFieldTouched(initialDateFieldName, false);
  };

  const handleOnBlurDate = () => {
    setFieldTouched(initialDateFieldName, true);
    setFieldTouched(endDateFieldName, true);
  };

  return (
    <CustomProvider locale={ptBR}>
      <FormControl fullWidth sx={{ position: 'relative' }}>
        <InputLabel
          htmlFor="range-picker"
          sx={
            fieldDate1.value
              ? labelStyles
              : {
                color: (fieldDate1.error && fieldDate1.touched) && '#d32f2f',
              }
          }
        >
          {inputLabel}
        </InputLabel>
        <Box id="range-picker">
          <DateRangePicker
            onBlur={handleOnBlurDate}
            placeholder=" "
            className={
              fieldDate1.error && fieldDate1.touched
                ? 'error'
                : ''
            }
            size="lg"
            format="dd/MM/yyyy"
            placement="auto"
            aria-describedby="range-picker-helper-text"
            editable={false}
            value={dateRange}
            onChange={handleChangeDate}
          />
        </Box>
        {fieldDate1.error && fieldDate1.touched && (
          <FormHelperText error id="range-picker-helper-text">
            {fieldDate1.error}
          </FormHelperText>
        )}
      </FormControl>
    </CustomProvider>
  );
}

export default DataRangePickerContext;
